module.exports = __webpack_public_path__ + "static/media/Sinsoft_Logo.ad2f40b4.png";